import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Dropdown } from "primereact/dropdown";
import RecentTransactionsTable from "./recent-transactions";

const CashFlowChart = ({ dashboardData, loading }) => {
  const [selectedMachine, setSelectedMachine] = useState("All");

  const kioskData = dashboardData?.cashFlowSummaries || [];

  const machines = [
    { label: "All", value: "All" },
    ...kioskData.map(({ kioskId }) => ({
      label: kioskId.replace("KIOSK-", "KIOSK "),
      value: kioskId,
    })),
  ];

  const filteredData =
    selectedMachine === "All"
      ? kioskData
      : kioskData.filter((k) => k.kioskId === selectedMachine);

  const allValues = filteredData.flatMap((k) => [
    k.cashIn,
    k.cashCollect,
    k.netFlow,
  ]);
  const maxValue = Math.max(...allValues, 1000);
  const stepSize = Math.ceil(maxValue / 5);

  const chartData = {
    labels: filteredData.map((k) => k.kioskId.replace("KIOSK-", "KIOSK ")),
    datasets: [
      {
        label: "Cash In",
        backgroundColor: "#26A69A",
        borderColor: "#00796B",
        data: filteredData.map((k) => k.cashIn),
      },
      {
        label: "Cash Collect",
        backgroundColor: "#FF7043",
        borderColor: "#E64A19",
        data: filteredData.map((k) => k.cashCollect),
      },
      {
        label: "Net Flow",
        backgroundColor: "#42A5F5",
        borderColor: "#1E88E5",
        data: filteredData.map((k) => k.netFlow),
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "Amount (PKR)" },
        ticks: {
          stepSize: stepSize,
        },
      },
    },
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h3 className="text-xl font-bold text-lg">Cash Flow Summary</h3>
        <Dropdown
          value={selectedMachine}
          options={machines}
          onChange={(e) => setSelectedMachine(e.value)}
          placeholder="Select Machine"
          className="mb-4"
        />
      </div>

      <Chart
        type="bar"
        className="cash-chart"
        data={chartData}
        options={chartOptions}
      />

      <RecentTransactionsTable
        dashboardData={dashboardData}
        loading={loading}
      />
    </>
  );
};

export default CashFlowChart;
